/* eslint-disable */
import React, {useState} from 'react';
import {useNavigate} from 'react-router-dom';
import 'contents/assets/scss/page/manage.scss';
import Tab from '../../component/Inc/Tab';
import Paging from '../../component/Inc/Paging';
import PopManageCompany from './_PopManageCompany';
import PopManageEmployee from './_PopManageEmployee';
import PopManageDepartment from './_PopManageDepartment';
function Employee() {
  const navigate = useNavigate();
  const [isOrderActive1, setIsOrderActive1] = useState(false);
  const [isOrderActive2, setIsOrderActive2] = useState(false);
  const [isOrderActive3, setIsOrderActive3] = useState(false);
  const [tabIdx, setTabIdx] = useState(0);
  const tab = [
    {title: '교무부', value: 0},
    {title: '출판사업부', value: 1},
    {title: '전략기획실', value: 2},
    {title: '홍보부', value: 3},
    {title: '입시전략부', value: 4},
    {title: '경영지원실', value: 5},
    {title: '교사', value: 6},
    {title: '퇴사자', type: 'red', value: 7}
  ];
  const [modalManageCompany, setModalManageCompany] = useState(false);
  const [modalManageEmployee, setModalManageEmployee] = useState(false);
  const [modalManageDepartment, setModalManageDepartment] = useState(false);
  return (
    <main className="com_container p_manage_employee">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu9_1">직원관리</h2>
          <div className="com_btn_wrap">
            <button onClick={() => setModalManageCompany(true)} className="com_btn orange s btn_settings">
              법인 관리
            </button>

            <button onClick={() => setModalManageDepartment(true)} className="com_btn orange s btn_settings">
              부서 관리
            </button>
            <button onClick={() => setModalManageEmployee(true)} className="com_btn orange s btn_plus">
              직원 등록
            </button>
          </div>
        </section>
        <section className="com_pg_container">
          {/* 수업정보 */}
          <section className="box full">
            <div className="com_board_list__top">
              <select className="select">
                <option value="이지수능 (본사)">이지수능 (본사)</option>
              </select>
              <Tab data={tab} tab={tabIdx} setTab={setTabIdx} />
              <section className="com_board_search end">
                <article className="search">
                  <input type="search" placeholder="교사명 검색" className="input s type_search" />
                  <button className="com_btn gray ws s icon_search"></button>
                </article>
              </section>
            </div>
            <hr className="com_divider" />
            <div className="com_board_list__top">
              <div className="board_select">
                <div className="check">
                  <input type="checkbox" name="chk" id="chk01" className="com_chk" />
                  <label htmlFor="chk01">전체</label>
                  <input type="checkbox" name="chk" id="chk02" className="com_chk" />
                  <label htmlFor="chk02">마케팅</label>
                  <input type="checkbox" name="chk" id="chk03" className="com_chk" />
                  <label htmlFor="chk03">디자인/IT</label>
                  <input type="checkbox" name="chk" id="chk04" className="com_chk" />
                  <label htmlFor="chk04">온라인컨텐츠팀</label>
                  <input type="checkbox" name="chk" id="chk05" className="com_chk" />
                  <label htmlFor="chk05">수시팀</label>
                </div>
              </div>
            </div>
            <table className="com_board_list">
              <colgroup>
                <col width="6%" />
                <col width="6%" />
                <col width="6%" />
                <col width="6%" />
                <col width="6%" />
                <col width="6%" />
                <col width="6%" />
                <col width="6%" />
                <col width="6%" />
                <col width="14%" />
                <col width="6%" />
                <col width="5%" />
              </colgroup>
              <thead>
                <tr>
                  <th>No.</th>
                  <th>
                    <button
                      onClick={() => {
                        setIsOrderActive1(!isOrderActive1);
                      }}
                      className={`arrow ${isOrderActive1 ? `active` : ``}`}
                    />
                    이름
                  </th>
                  <th>소속</th>
                  <th>부서</th>
                  <th>부서</th>
                  <th>법인</th>
                  <th>연락처</th>
                  <th>직급</th>
                  <th>
                    <button
                      onClick={() => {
                        setIsOrderActive2(!isOrderActive2);
                      }}
                      className={`arrow ${isOrderActive2 ? `active` : ``}`}
                    />
                    담당 교사
                  </th>
                  <th>주소</th>
                  <th>
                    <button
                      onClick={() => {
                        setIsOrderActive3(!isOrderActive3);
                      }}
                      className={`arrow ${isOrderActive3 ? `active` : ``}`}
                    />
                    등록일
                  </th>
                  <th>상세보기</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>1</td>
                  <td>
                    <button className="btn_link">홍직원123</button>
                  </td>
                  <td>본사</td>
                  <td>전략기회실</td>
                  <td>마케팅</td>
                  <td>(주)이지올댓</td>
                  <td>010-2323-2222</td>
                  <td>과장 3호봉</td>
                  <td>20</td>
                  <td>경기도 용인시</td>
                  <td className="td_date">2022.08.25 12:30</td>
                  <td>
                    <button
                      onClick={() => {
                        navigate('/Manage/Employee/Info');
                      }}
                      className="btn_link blue"
                    >
                      보기
                    </button>
                  </td>
                </tr>
                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i, idx) => {
                  return (
                    <tr key={idx}>
                      <td>{idx + 1}</td>
                      <td>
                        <button className="btn_link">홍직원123</button>
                      </td>
                      <td>본사</td>
                      <td>전략기회실</td>
                      <td>마케팅</td>
                      <td>(주)이지올댓</td>
                      <td>010-2323-2222</td>
                      <td>과장 3호봉</td>
                      <td>20</td>
                      <td>경기도 용인시</td>
                      <td className="td_date">2022.08.25 12:30</td>
                      <td>
                        <button
                          onClick={() => {
                            navigate('/Manage/Employee/Info');
                          }}
                          className="btn_link blue"
                        >
                          보기
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <Paging />
            <div className="com_board_list__bottom">
              <div className="com_btn_wrap center btn_fixed right">
                <button className="com_btn black xs btn_down_orange">다운로드</button>
              </div>
            </div>
          </section>
        </section>
      </div>
      <PopManageCompany open={modalManageCompany} close={() => setModalManageCompany(false)} />
      <PopManageEmployee open={modalManageEmployee} close={() => setModalManageEmployee(false)} />
      <PopManageDepartment open={modalManageDepartment} close={() => setModalManageDepartment(false)} />
    </main>
  );
}

export default Employee;
